import React from 'react';
import PropTypes from 'prop-types';
import ImageA from 'components/Image/ImageA';
import classes from './CardBlogC.module.scss';

const CardBlogC = (props) => {
  const {
    title,
    image,
    imageAltText,
    url,
    target,
    imageHeight,
    imageWidth,
    shortDescription,
  } = props;

  let Component = 'div';
  let componentProps = {};

  // if there is a url then make the container a link
  if (url) {
    Component = 'a';
    componentProps = { href: url, target };
  }

  return (
    <div className={classes.container}>
      <Component className={classes.imageContainer} {...componentProps}>
        <ImageA
          className={classes.image}
          altText={imageAltText}
          url={image}
          width={imageWidth}
          height={imageHeight}
        />
        {title && <div className={classes.title} dangerouslySetInnerHTML={{ __html: title }} />}
      </Component>
      {shortDescription &&
        <div className={classes.shortDescription} dangerouslySetInnerHTML={{ __html: shortDescription }} />}
    </div>
  );
};

CardBlogC.propTypes = {
  /**
   * Text displays directly below the image
  */
  title: PropTypes.string,
  /**
   * Url of the image
  */
  image: PropTypes.string,
  /**
   * Alt text for image
  */
  imageAltText: PropTypes.string,
  /**
   * Link url for image
  */
  url: PropTypes.string,
  /**
   * Target for where to open link
  */
  target: PropTypes.string,
  /**
   * Image height
  */
  imageHeight: PropTypes.number,
  /**
   * Image width
  */
  imageWidth: PropTypes.number,
  /**
   * Text shows up under title
  */
  shortDescription: PropTypes.string,
};

export default CardBlogC;
